











import { Component, Vue } from 'vue-property-decorator'
import TranslationModule from '@/utils/TranslationModule'
import BaseButton from '@/components/reusable-components/controls/BaseButton.vue'
import { ButtonSize, ButtonTheme } from '@/utils/ButtonAttr'
@Component({
    components: { BaseButton },
})
export default class HeaderNewsletterCard extends Vue {
    TranslationModule: typeof TranslationModule = TranslationModule
    ButtonTheme: typeof ButtonTheme = ButtonTheme
    ButtonSize: typeof ButtonSize = ButtonSize
}
